import { render, staticRenderFns } from "./nbGeomagnetism.vue?vue&type=template&id=209f6c6c&scoped=true"
import script from "./nbGeomagnetism.vue?vue&type=script&lang=js"
export * from "./nbGeomagnetism.vue?vue&type=script&lang=js"
import style0 from "./nbGeomagnetism.vue?vue&type=style&index=0&id=209f6c6c&prod&scoped=true&lang=css"
import style1 from "./nbGeomagnetism.vue?vue&type=style&index=1&id=209f6c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f6c6c",
  null
  
)

export default component.exports